import { scannerPatientListDefaults } from "@/core/model/integrations"

import type {
  ScannerFileEntry,
  ScannerFilesResult,
  ScannerPatientListQueryParams,
} from "./integrations.type"

/**
 * Builds a JSON-serializable body for paginated list POSTs: clamped `page` / `page_size`,
 * optional trimmed `search` and `doctor` when present.
 */
export function buildScannerPatientListBody(
  params: ScannerPatientListQueryParams,
): Record<string, string | number> {
  const {
    search,
    doctor,
    page = 1,
    page_size: pageSizeIn = scannerPatientListDefaults.defaultPageSize,
    external_case_id,
  } = params
  const page_size = Math.min(
    scannerPatientListDefaults.maxPageSize,
    Math.max(1, pageSizeIn),
  )
  const q: Record<string, string | number> = { page, page_size }
  const s = search?.trim()
  if (s) q.search = s
  const d = doctor?.trim()
  if (d) q.doctor = d
  if (external_case_id) q.external_case_id = external_case_id
  return q
}

/** Extract `{ upper, lower }` scan entries from a `/files/load` response `files` object. */
export const extractScanFiles = (
  files: ScannerFilesResult,
): { upper: ScannerFileEntry | null; lower: ScannerFileEntry | null } => ({
  upper: files.upper ?? null,
  lower: files.lower ?? null,
})

/** Extract the photos array from a `/files/load` response `files` object. */
export const extractPhotoFiles = (files: ScannerFilesResult): ScannerFileEntry[] =>
  files.photos ?? []
